<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="showModal" :title="$t('Current Selection')" @show="onShow" size="md"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :show-confirmation="false"
                   :ok-title="$t('Submit')" scrollable>

      <table class="table table-sm">
        <tr>
          <th v-for="col in columns" :key="`artisio-selection-modal-title-${col.name}`"
              class="border-top-0">
            {{ col.name }}
          </th>
        </tr>
        <tr v-for="item in items" :key="`artisio-selection-row-${item.uuid}`">
          <td v-for="col in columns" :key="`artisio-selection-cell-${item.uuid}-${col.name}`">
            {{ col.displayFn(item) }}
          </td>
          <td>
            <font-awesome-icon
              class="text-danger hover-cursor" :id="`remove-button-${item.uuid}`"
              icon="times" @click="onRemoveItemClick(item)">
            </font-awesome-icon>
          </td>
        </tr>
      </table>

    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "./../artisio-modal/ArtisioModal";

  const {mapState, mapActions} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "ArtisioTableSelectionModal",
    components: {ArtisioModal},
    data: () => {
      return {
        items: [],
        removedItemUuids: []
      }
    },
    computed: {
      ...mapState({
        showModal: state => state.artisioTableSelectionModal.show,
        modalItems: state => state.artisioTableSelectionModal.items,
        columns: state => state.artisioTableSelectionModal.columns,
        tableIdentifier: state => state.artisioTableSelectionModal.tableIdentifier,
      }),
    },
    methods: {
      ...mapActions(['hideArtisioTableSelectionModal']),
      onShow() {
        this.items = this.modalItems
      },
      onHidden() {
        this.items = []
        this.removedItemUuids = []
        this.hideArtisioTableSelectionModal();
      },
      onRemoveItemClick(item) {
        this.removedItemUuids.push(item.uuid)
        this.items.delete(item)
        this.items = new Set(this.items)
      },
      async onSubmit() {
        if (this.removedItemUuids.length > 0) {
          let confirm = await this.$confirm(this.$i18n.t('{total} item(s) will be removed from selection. Are you sure you want to proceed?', {total: this.removedItemUuids.length}))
          if (!confirm) {
            return false
          }
          this.$evBus.$emit(`artisioTableSelectionSubmit-${this.tableIdentifier}`, {removedItemUuids: this.removedItemUuids})
          this.hideArtisioTableSelectionModal()
        } else {
          this.hideArtisioTableSelectionModal()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>

